import type { FC, ReactNode } from 'react'
import type { GetServerSideProps } from 'next'
import type { CrmPageProps } from '@/lib/crm-page'

import AppShell from '@/components/generals/app-shell'
import PageHeader from '@/components/generals/page-header'
import ForecastView from '@/components/forecast/forecast-view'
import { loadCrmPageProps } from '@/lib/crm-page'
import { quarterOf } from '@/lib/dates'

type ForecastPageProps = Partial<CrmPageProps> & {
    quarter: string
}

const ForecastPage: FC<ForecastPageProps> = ({ data, today, quarter }): ReactNode => {
    return (
        <AppShell data={data} today={today ?? ''} title="Forecast" description="Quarterly forecast by stage, month and owner.">
            <PageHeader title="Forecast" tabs />
            <ForecastView initialQuarter={quarter} />
        </AppShell>
    )
}

export const getServerSideProps: GetServerSideProps<ForecastPageProps> = async () => {
    const props = await loadCrmPageProps()

    return { props: { ...props, quarter: quarterOf(props.today).key } }
}

export default ForecastPage
